export const handleLastNameKeyPress = (e) => {
    const char = e.key;
    const input = e.target;
    const value = input.value;
    const cursorPosition = input.selectionStart;
  
    const allowedKeys = [
      "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"
    ];
  
    const isLetterOrSpace = /^[a-zA-Z ]$/.test(char);
  
    if (allowedKeys.includes(char)) return;
  
    if (!isLetterOrSpace) {
      e.preventDefault();
      return;
    }
  
    if (cursorPosition === 0 && char === " ") {
      e.preventDefault();
      return;
    }
  
    const prevChar = value.charAt(cursorPosition - 1);
    if (char === " " && prevChar === " ") {
      e.preventDefault();
      return;
    }
  };
  
export const handleLastNameInput = (e) => {
    // Remove all unintended periods (like from double space)
    const cleanValue = e.target.value.replace(/\.{1,}/g, "");
    if (e.target.value !== cleanValue) {
      e.target.value = cleanValue;
    }
  };
export const handleLastNameBlur = (e, form) => {
    const cleanValue = e.target.value.trim();
    form.setFieldsValue({ last_name: cleanValue });
  }